import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ComponentModule } from '~/component/component.module';
import { ToastsServiceComponent } from '~/notifications/toasts/toasts-service.component';

@NgModule({
  declarations: [ToastsServiceComponent],
  imports: [CommonModule, ComponentModule],
  exports: [ToastsServiceComponent],
})
export class NotificationsModule {}
